import { addsecuProducts } from "../../../app/slices/shoppingsecuSlice";
import AddtocartsecuService from "../../../services/AddtocartsecuService";

export const loadProducts = () => (dispatch, getState) => {
  AddtocartsecuService.fetchAllAddtocartsecu()
    .then((response) => {
      dispatch(addsecuProducts(response?.data));
    })
    .catch((err) => {});
};
